/* The belows are thunk objects, i.e. react thunk middlewares allow you to
   write action that return a function instead of an action object.
   see https://github.com/reduxjs/redux-thunk

   ((Thunk objects have 'dispatch' and 'getState' provided by the middleware.))
   */

import {userSubmittedFeedbackAction} from "../actions";

export const postUserFeedbackAction = (userEmail, userFeedback) => {
    return (dispatch, getState) => {
        const message = "user: [ " + userEmail + " ] submitted feedback: [ "+userFeedback+" ]. ";
        const { csrfToken } = getState();
        let url = '/api/feedback/post';

        fetch(url, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({"userEmail": userEmail, "userFeedback": userFeedback}),
            headers: {
                'X-XSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json'
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                let record = message + " Message submitted successfully. ";
                dispatch(userSubmittedFeedbackAction(record));
            })
            .catch(err => {
                let record = message + " Message submission resulted in error: [ " + JSON.stringify(err) + "]. ";
                dispatch(userSubmittedFeedbackAction(record));
            })
            .finally(

            )
    }
};
